export default "dist/barretenberg.wasm";